import { useTranslation } from 'react-i18next';
import { colors } from 'components/styles/variables';
import LocationInputNoDialog, { getLocationLabel } from 'components/LocationInputNoDialog';
import HeaderLocationTapEvent from 'lib/Tracking/Srp/SearchFilters/HeaderLocationTap';
import useEvents from 'lib/hooks/useEvents';
import { useLocationFilter } from 'lib/hooks/useSrpFilters';
import { useContext } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';
import TopBarDropdownContainer from './TopBarDropdownContainer';

export default function LocationFilterCta(): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const { value } = useLocationFilter();
  const srpEventContext = useContext(SrpEventContext);

  const label = getLocationLabel(t, value);

  return (
    <div className="location-filter-cta-container">
      <TopBarDropdownContainer
        title={t('srp.topBar.location')}
        placeHolderCtaText={label}
        filter="location"
        handleClick={(): Promise<void> =>
          logger.log(HeaderLocationTapEvent({ sourcePage: srpEventContext.sourcePage }))
        }
      >
        <LocationInputNoDialog className="location-autocomplete-container" />
      </TopBarDropdownContainer>
      <style jsx>{`
        .location-filter-cta-container {
          width: 140px;
          height: 42px;
          border-radius: 8px;
          padding-left: 12px;
          padding-right: 8px;
          cursor: pointer;
          white-space: nowrap;
          line-height: 1px;
        }

        .location-filter-cta-container:hover {
          background-color: ${colors.G1};
        }
      `}</style>
    </div>
  );
}
